export const calculateExpireDate = (days = 365) => {
    const expireDate = new Date();
    expireDate.setDate(expireDate.getDate() + days);
    return expireDate;
};
//# sourceMappingURL=calculateExpireDate.js.map